/**
 * @author: lihuimin25
 * @description: 日常活动 - 规则圈选页面  roomId-会场id，blockId-收品池编号，activityId-活动id
 */
import React, { useEffect, useCallback, useState, useContext } from 'react';
import { getQuery } from '@/common/utils';
import CardWarp from '@/components/card-warp';
import ProductStrategyList from './ProductStrategyList';
import { queryDucc } from '@/apis/marketingField/materialCollection';
import env from '@/env';
import { message } from 'antd';
import { strategyItem } from '@/pages/platform-marketing-position/resource-detail/material-collection/components/rule-collection';
import StrategyDom from '@/pages/platform-marketing-position/resource-detail/material-collection/components/rule-collection/strategy-dom';
import { ActivityVersionEnum } from '@/pages/platform-marketing-position/resource-detail/material-collection/components/rule-collection/interface';
import TabsWrapper from '@/pages/platform-marketing-position/resource-detail/material-collection/components/rule-collection/tabs-wrapper';
import CategoryHp from '@/pages/activity-manage/merchants/detail/components/category-hp';
import { newPandoraLink, newPandoraConfig, useRuleId } from '@/micro-app/context/new-pandora-config';

import './index.less';

const prefix = 'rule-collection-0331';
const RuleCollection = () => {
  useEffect(() => {}, []);
  const planCode = 'HD202112102036523447';
  let activityId = getQuery('activityId');
  const [fullScreen, setFullScreen] = useState(false);
  const [listinfo, setListInfo] = useState<{ loading: boolean; list: strategyItem[] }>({
    loading: false,
    list: [],
  });
  const [plancodeChannelType, setPlancodeChannelType] = useState(44);

  /* 舍弃走下面，配置化的 */
  // useEffect(() => {
  //   setListInfo({ loading: true, list: [] });
  //   const isDevelop = ['test1.yx.jd.com', 'localhost.jd.com:10000'].indexOf(window.location.host) > -1;
  //   const params = isDevelop ? 'sourceCms.yth.regular.selection.beta' : 'sourceCms.yth.regular.selection';
  //   queryDucc({ duccKey: params })
  //     .then((res) => {
  //       const { ret, msg, data } = res;
  //       if (ret === '0') {
  //         try {
  //           const data1 = JSON.parse(data?.data) || [];
  //           setListInfo({
  //             loading: false,
  //             list: [
  //               ...data1,
  //               {
  //                 name: '通用精选底池',
  //                 poolType: '53',
  //                 description: '以全站精选店铺为底池，支持多规则选店。多场景复用',
  //                 scene: '频道、活动页',
  //                 materialType: '5',
  //                 picUrl: 'https://storage.360buyimg.com/launch/launch-pandora/common_shop_100x154.png',
  //                 background: 'linear-gradient(rgba(255,248,247,1), rgba(255,255,255,0.5))',
  //               },
  //             ],
  //           });
  //         } catch (error) {
  //           setListInfo({ loading: false, list: [] });
  //           console.log(error, '解析duccInfo失败');
  //         }
  //       } else {
  //         throw msg || '促销选品配置信息获取错误！';
  //       }
  //     })
  //     .catch((ex) => {
  //       message.error(ex);
  //       setListInfo({ loading: false, list: [] });
  //     });
  // }, []);

  /**
   * 2023.02.27 便宜包邮频道需求引发，类似这个特殊的频道，这个频道下，去选品采用的channelType由原来固定的44改成了35，不是这个频道的还是44
   * 这样配置成DUCC，以后类似的需求，再增加规则底池，全部读DUCC，一个频道对应一个channelType，DUCC读不到的全部走老的规则池44
   * 通过DUCC获取 plancode 和 channelType[规则底池ID] 的关系映射表，同时取出第二步ducc需要的key，因为第二个ducc对于特殊的频道时可能需要特殊key
   * 日常活动也增加配置化
   */
  const memoizedFetchData = useCallback(async () => {
    const roomId = getQuery('roomId') || '';
    const isDevelop = ['test1.yx.jd.com', 'localhost.jd.com:10000'].indexOf(window.location.host) > -1;
    const paramsRegularDefault = isDevelop ? 'sourceCms.yth.regular.selection.beta' : 'sourceCms.yth.regular.selection';

    let regularDuccKey = paramsRegularDefault;
    // 优先去获取ducc看看这个日常的roomId有没有特殊的channelType
    const params = 'pandora.yx.channelId.config';
    const { ret: ret1, msg: msg1, data: data2 } = await queryDucc({
      duccKey: params,
    });
    if (ret1 === '0') {
      const data3 = (data2?.data && JSON.parse(data2?.data)) || '';
      if (data3) {
        const duccPlancodeArr = Object.keys(data3);
        if (duccPlancodeArr.includes(roomId)) {
          setPlancodeChannelType(data3[roomId]?.channelType || 44);

          // 已改成配置化，在ducc里
          regularDuccKey = isDevelop ? data3[roomId]?.regularDuccKey : data3[roomId]?.regularDuccKeyProd;
        }
      }
    } else {
      setPlancodeChannelType(44);
      regularDuccKey = paramsRegularDefault;
      message.error(`${msg1 || '获取门槛规则配置异常,请您稍后重试！'}`);
    }

    // 走第二个DUCC接口
    setListInfo({ loading: true, list: [] });
    const { ret, msg, data } = await queryDucc({
      duccKey: regularDuccKey || paramsRegularDefault,
    });
    if (ret === '0') {
      const data1 = (data?.data && JSON.parse(data?.data)) || [];
      setListInfo({
        loading: false,
        list: [
          ...data1,
          {
            name: '通用精选底池',
            poolType: '53',
            description: '以全站精选店铺为底池，支持多规则选店。多场景复用',
            scene: '频道、活动页',
            materialType: '5',
            picUrl: 'https://storage.360buyimg.com/launch/launch-pandora/common_shop_100x154.png',
            background: 'linear-gradient(rgba(255,248,247,1), rgba(255,255,255,0.5))',
          },
        ],
      });
    } else {
      setListInfo({ loading: false, list: [] });
      message.error(`${msg || '促销选品配置信息获取错误！！'}`);
    }
  }, []);

  useEffect(() => {
    memoizedFetchData();
  }, [memoizedFetchData]);

  const ruleIdRef = useRuleId();
  const newPoolTypes = useContext(newPandoraConfig);

  /* **********业务代码*************** */
  // 促销玩法选品-去选品
  const toSalePlaySelect = (poolType: number, materialType?: string) => {
    if (!activityId) {
      message.info('请检查是否有活动ID');
      return;
    }
    const roomId = getQuery('roomId'),
      blockId = getQuery('blockId');
    let link = '';
    if (materialType === '5') {
      const oldLink = `/pandoraacore/#/shop/manage?poolType=${poolType}&jumpTo=WDSC&channelId=${roomId}&channelType=${
        plancodeChannelType || 44
      }&resourceId=${blockId}&activityType=11&yxActivityId=${activityId}`;
      const newLink = `/selection/#/selection/shop/manage?poolType=${poolType}&jumpTo=WDSC&channelId=${roomId}&channelType=${
        plancodeChannelType || 44
      }&resourceId=${blockId}&activityType=11&yxActivityId=${activityId}`;

      link = newPandoraLink(poolType, newPoolTypes, oldLink, newLink);
    } else if (materialType === '7') {
      link = `${env.RANK_LIST}/ace?jumpTo=WDSC&channelId=${roomId}&resourceId=${blockId}&yxActivityId=${activityId}`;
    } else {
      const newLink = `/selection/#/selection/manage/${poolType}?thresholdRuleId=${
        ruleIdRef.current ?? ''
      }&jumpTo=WDSC&channelId=${roomId}&channelType=${
        plancodeChannelType || 44
      }&resourceId=${blockId}&activityType=11&yxActivityId=${activityId}`;
      const oldLink = `/pandoraacore/#/integration/manage/${poolType}?jumpTo=WDSC&channelId=${roomId}&channelType=${
        plancodeChannelType || 44
      }&resourceId=${blockId}&activityType=11&yxActivityId=${activityId}`;

      link = newPandoraLink(poolType, newPoolTypes, oldLink, newLink);
    }
    (window as any)?.log?.('ace_yx', 'goods_selecthd', roomId, activityId, poolType);
    window.open(link);
  };

  // 总价促销和优惠券的去选品链接
  const toSalePlaySelectAndPromotionId = useCallback(
    function ({
      planCode: innerPlanCode,
      poolType /*17:总价促销 | 32 优惠券*/,
    }: {
      planCode: string;
      poolType: string;
    }) {
      if (!planCode || !poolType) {
        console.error('非法入参跳转会出错', planCode, poolType);
      }
      const link = `/pandoraacore/#/integration/coupon-list?jumpTo=WDSC&yxActivityId=${activityId}&activityId=${innerPlanCode}&scene=main&poolType=${poolType}`;
      window.open(link);
    },
    // eslint-disable-next-line
    []
  );

  const handelClose = () => {
    setFullScreen(false);
  };

  /** 点击活动卡片跳转 */
  const toYxPage = useCallback(
    (poolId: string | undefined, activityVersion: ActivityVersionEnum, code: string) => {
      const roomId = getQuery('roomId'),
        blockId = getQuery('blockId');
      if (!poolId) {
        message.warn('未返回poolId');
        return;
      }
      let link = '';
      if (activityVersion === ActivityVersionEnum.NEW_ZHAOSHANG) {
        // 去营销活动选品页面
        link = `/pandoraacore/#/integration/yx-activity?activityId=${code}&poolId=${poolId}&jumpTo=WDSC&channelId=${roomId}&channelType=${
          plancodeChannelType || 44
        }&resourceId=${blockId}&activityType=11&yxActivityId=${activityId}`;
      } else {
        // 跳转至poolType2 带上当前活动id { id: poolId, activityId: planCode, type: '2'
        link = `/pandoraacore/#/integration/manage/${poolId}/${code}/2?jumpTo=WDSC&channelId=${roomId}&channelType=${
          plancodeChannelType || 44
        }&resourceId=${blockId}&activityType=11&yxActivityId=${activityId}`;
      }
      window.open(link);
    },
    [activityId, plancodeChannelType]
  );

  const escFunction = useCallback(() => {
    if (!checkIsFullScreen()) {
      setFullScreen(false);
    }
  }, []);

  const checkIsFullScreen = () => {
    const isFullScreen = document.fullscreen;
    return isFullScreen == undefined ? false : isFullScreen;
  };

  useEffect(() => {
    document.addEventListener('webkitfullscreenchange', escFunction);
    document.addEventListener('mozfullscreenchange', escFunction);
    document.addEventListener('fullscreenchange', escFunction);
    document.addEventListener('msfullscreenchange', escFunction);
    return () => {
      //销毁时清除监听
      document.removeEventListener('webkitfullscreenchange', escFunction);
      document.removeEventListener('mozfullscreenchange', escFunction);
      document.removeEventListener('fullscreenchange', escFunction);
      document.removeEventListener('MSFullscreenChange', escFunction);
    };
  }, [escFunction]);

  return (
    <div className={`${prefix}-wrapper`}>
      <TabsWrapper
        isDaily={true}
        listinfo={listinfo}
        toSalePlaySelect={toSalePlaySelect}
        toSalePlaySelectAndPromotionId={toSalePlaySelectAndPromotionId}
        handleFullScreen={() => {
          setFullScreen(true);
          (window as any)?.log?.('ace_yx', 'full_viewhd', activityId);
        }}
      />
      {/* "品类货盘" */}
      <CategoryHp activityId={getQuery('roomId')} activityType={CategoryHp.DAILY} />
      <div className={`${prefix}-item`}>
        <CardWarp
          title="当前活动的商品策略"
          extra="基于场域运营导向通过规则进行商品策略创建，可从创建后的商品策略中，再通过规则叠加形成可直接关联资源位上场的商品组。"
        >
          <ProductStrategyList />
        </CardWarp>
      </div>
      {fullScreen && (
        <StrategyDom
          onCancel={handelClose}
          toSalePlaySelectAndPromotionId={toSalePlaySelectAndPromotionId}
          toSalePlaySelect={toSalePlaySelect}
          planCode={planCode!}
          listinfo={listinfo}
          toYxPage={toYxPage}
        />
      )}
    </div>
  );
};

export default RuleCollection;
